$(document).ready(function(){

$('.style-with-slider').slick({
  dots: true,
  infinite: true,
  prevArrow: '<button class="slick-prev slick-arrow slider-arrow-ver flex  justify-center" aria-label="Previous" ><svg aria-hidden=true class="icon icon--direction-aware icon-arrow-left"fill=none focusable=false viewBox="0 0 16 18"width=16><path d="M11 1 3 9l8 8"stroke=currentColor stroke-linecap=square></path></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow slider-arrow-ver flex  justify-center" aria-label="Next" ><svg aria-hidden=true class="icon icon--direction-aware icon-arrow-right"fill=none focusable=false viewBox="0 0 16 18"width=16><path d="m5 17 8-8-8-8"stroke=currentColor stroke-linecap=square></path></svg></button>',  
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


if($('[data-block-type="styled-with"] .accordion__toggle').length){
  $('[data-block-type="styled-with"] .accordion__toggle:eq(0)').trigger("click");
}

  
})  